import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var RoleHelper = function RoleHelper() {
  _classCallCheck(this, RoleHelper);

  _defineProperty(this, "ROLES", {
    MHDC_WRITE: {
      name: "MHDC_WRITE",
      value: 1
    },
    MHDC_READ: {
      name: "MHDC_READ",
      value: 2
    },
    GENERAL_USER: {
      name: "GENERAL_USER",
      value: 3
    },
    MANAGEMENT_COMPANY_PRIMARY_USER: {
      name: "MANAGEMENT_COMPANY_PRIMARY_USER",
      value: 4
    }
  });
};

export default new RoleHelper();